import React, { HTMLAttributes, useState } from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { fade } from "@material-ui/core/styles";

// import PrevArrow from "assets/svgs/icons/swiperArrows/PrevArrow";
// import NextArrow from "assets/svgs/icons/swiperArrows/NextArrow";

import Swiper, { SwiperInstance } from "react-id-swiper";
import "swiper/css/swiper.css";
import clsx from "clsx";
import IconButton from "@material-ui/core/IconButton";

const useStyles = makeStyles((theme: Theme) => {
    const buttonBackgroundColour = theme.palette.common.white;

    return createStyles({
        root: {
            overflow: "hidden",
            position: "relative",
        },
        swipperContainer: {},
        buttonContainer: {
            position: "absolute",
            zIndex: 200,
            height: "100%",
            display: "flex",
            alignItems: "center",
        },
        previousButtonContainer: {
            left: 0,
        },
        nextButtonContainer: {
            right: 0,
        },
        iconButton: {
            backgroundColor: fade(buttonBackgroundColour, 0.7),
            "&:hover": {
                backgroundColor: fade(buttonBackgroundColour, 0.9),
            },
            margin: theme.spacing(1),
            cursor: "pointer",
            borderRadius: 0,
        },
        button: { fontSize: 50, color: theme.palette.primary.main },
        previousButton: {},
        nextButton: {},
    });
});

interface IProps extends HTMLAttributes<HTMLDivElement> {
    slides: JSX.Element[];
}

export default function GallerySwiper(props: IProps) {
    const { slides, className, ...rest } = props;
    const classes = useStyles();

    const [swiper, setSwiper] = useState<SwiperInstance>();

    const goNext = () => {
        if (swiper !== null) {
            swiper.slideNext();
        }
    };

    const goPrev = () => {
        if (swiper !== null) {
            swiper.slidePrev();
        }
    };

    const params = {
        containerClass: classes.swipperContainer,
        slidesPerView: "auto",
        loop: true,
        loopedSlides: 1,
    };

    return (
        <div className={clsx(className, classes.root)} {...rest}>
            {slides.length > 1 ? (
                <>
                    <div className={clsx(classes.buttonContainer, classes.previousButtonContainer)}>
                        <IconButton
                            className={clsx(classes.iconButton, classes.previousButton)}
                            onClick={() => goPrev()}
                        >
                            {/* <PrevArrow className={classes.button} /> */}
                            prev
                        </IconButton>
                    </div>
                    <div className={clsx(classes.buttonContainer, classes.nextButtonContainer)}>
                        <IconButton
                            className={clsx(classes.iconButton, classes.nextButton)}
                            onClick={() => goNext()}
                        >
                            {/* <NextArrow className={classes.button} /> */}
                            next
                        </IconButton>
                    </div>
                    <Swiper getSwiper={setSwiper} {...params}>
                        {slides}
                    </Swiper>
                </>
            ) : (
                slides
            )}
        </div>
    );
}
